import React from "react";
import { ProductList } from "./ProductList";

export const Products = () => {

  return (
    <div>
      <div style={{ marginTop: "15%" }}>
        <ProductList />
          
      </div>
    </div>
  );
};

